<script setup>

</script>

<template>

    <div class="mt-8 md:mt-5 md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
            <div class="px-4 sm:px-0">

                <span class="text-lg font-medium leading-6 text-gray-900" aria-hidden="true">

                    <slot name="title"></slot>

                </span>

                <p class="mt-1 text-sm leading-5 text-gray-600" aria-hidden="true">

                    <slot name="description"></slot>

                </p>

            </div>
        </div>

        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="shadow sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6">
                    <div class="grid grid-cols-4 gap-x-6 gap-y-8">

                        <slot name="inputs"></slot>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>

</style>